import { css } from "@emotion/react";

export const closeButtonStyles = css`
    appearance: none;
    border: none;
    position: absolute;
    top: 0;
    right: -20%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    background-color: red;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: white;
`;

export const imgWrapperStyles = css`
    height: 140px;
    display: inline-block;
    width: 100%;
`;

